(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function updateBurnRail() {
    var rail = document.querySelector('.eyeful-v6-shell .burn');
    if (!rail) return;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var ratio = max > 0 ? Math.min(1, window.scrollY / max) : 0;
    rail.style.setProperty('--burnt', (ratio * 100).toFixed(2) + '%');
  }

  function reveal() {
    var elements = document.querySelectorAll('[data-reveal]');
    if (reduce || !('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('on'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('on');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    elements.forEach(function (el) { observer.observe(el); });
  }

  function smoke(canvas) {
    if (reduce || !canvas.getContext) return;
    var context = canvas.getContext('2d');
    var particles = [];
    var width = 0;
    var height = 0;
    var startX = parseFloat(canvas.dataset.x || '.5');
    var startY = parseFloat(canvas.dataset.y || '.5');
    var soft = canvas.dataset.soft === '1';
    function resize() { width = canvas.width = canvas.offsetWidth; height = canvas.height = canvas.offsetHeight; }
    function spawn() { particles.push({ x: width * startX + (Math.random() - .5) * 6, y: height * startY, r: 2 + Math.random() * 3, a: soft ? .09 : .15, vy: .35 + Math.random() * .5, drift: Math.random() * 6.28, dv: .004 + Math.random() * .01, sway: .14 + Math.random() * .3 }); }
    function draw() {
      if (!canvas.isConnected) return;
      context.clearRect(0, 0, width, height);
      if (particles.length < 70 && Math.random() < .5) spawn();
      for (var i = particles.length - 1; i >= 0; i -= 1) {
        var p = particles[i]; p.y -= p.vy; p.drift += p.dv * 8; p.x += Math.sin(p.drift) * p.sway; p.r += .055; p.a -= .0011;
        if (p.a <= 0 || p.y < -20) { particles.splice(i, 1); continue; }
        var gradient = context.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
        gradient.addColorStop(0, 'rgba(226,219,205,' + p.a + ')'); gradient.addColorStop(1, 'rgba(226,219,205,0)');
        context.fillStyle = gradient; context.beginPath(); context.arc(p.x, p.y, p.r, 0, 6.29); context.fill();
      }
      window.requestAnimationFrame(draw);
    }
    resize(); window.addEventListener('resize', resize); draw();
  }

  function wireGallery() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (item) { item.setAttribute('aria-selected', 'false'); });
        button.setAttribute('aria-selected', 'true');
        if (!reduce) main.classList.add('swapping');
        window.setTimeout(function () { main.src = button.dataset.src; main.srcset = ''; main.classList.remove('swapping'); }, reduce ? 0 : 180);
      });
    });
  }

  function wireFilters() {
    var cards = document.querySelectorAll('[data-product-kind]');
    if (!cards.length) return;
    document.querySelectorAll('[data-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.dataset.filter;
        document.querySelectorAll('[data-filter]').forEach(function (item) { item.setAttribute('aria-pressed', String(item === button)); });
        cards.forEach(function (card) { card.hidden = value !== 'all' && card.dataset.productKind !== value; });
      });
    });
  }

  function wireProductForm() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var quantity = form.querySelector('[data-qty]');
    form.querySelectorAll('[data-q]').forEach(function (button) {
      button.addEventListener('click', function () { quantity.value = Math.max(1, Number(quantity.value || 1) + Number(button.dataset.q)); });
    });
    var select = form.querySelector('[data-variant-select]');
    if (select) select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var price = document.querySelector('[data-product-price]');
      var submit = form.querySelector('[data-add-label]');
      if (price) price.textContent = option.dataset.price;
      submit.disabled = option.dataset.available !== 'true';
      submit.textContent = submit.disabled ? 'Sold out' : 'Add to bag';
      window.history.replaceState({}, '', window.location.pathname + '?variant=' + option.value);
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var submit = form.querySelector('[data-add-label]');
      var message = form.querySelector('[data-product-message]');
      submit.disabled = true; submit.textContent = 'Adding…'; message.textContent = '';
      fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (response) { if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add this unit.'); }); return response.json(); })
        .then(function () { return fetch(window.Shopify.routes.root + 'cart.js'); })
        .then(function (response) { return response.json(); })
        .then(function (cart) { document.querySelectorAll('[data-cart-count]').forEach(function (count) { count.textContent = cart.item_count; }); message.textContent = 'ADDED TO BAG.'; submit.disabled = false; submit.textContent = 'Add to bag'; })
        .catch(function (error) { message.textContent = error.message; submit.disabled = false; submit.textContent = 'Add to bag'; });
    });
  }

  function refreshCartCount() {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (count) {
          count.textContent = cart.item_count;
        });
        document.querySelectorAll('.head__cart').forEach(function (link) {
          link.setAttribute('aria-label', 'Bag with ' + cart.item_count + ' items');
        });
      });
  }

  function wireNativeCartUpdates() {
    if (!document.body.classList.contains('template-cart')) return;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!button) return;
      var label = button.getAttribute('aria-label') || '';
      if (/^(Remove|Increase quantity|Decrease quantity)/i.test(label)) {
        window.setTimeout(refreshCartCount, 900);
        window.setTimeout(refreshCartCount, 2200);
      }
    });
    document.addEventListener('change', function (event) {
      if (event.target.matches('input[name="updates[]"], input[name="quantity"]')) {
        window.setTimeout(refreshCartCount, 1200);
      }
    });
    refreshCartCount();
  }

  document.querySelectorAll('[data-smoke]').forEach(smoke);
  reveal(); wireGallery(); wireFilters(); wireProductForm(); wireNativeCartUpdates(); updateBurnRail();
  window.addEventListener('scroll', updateBurnRail, { passive: true });
})();
